export const dateConfig = {
  isDateOnly: true,
};

export const COMMON_DATE_FORMAT = 'MM/dd/yyyy';
export const COMMON_DATE_FORMAT_DAYJS = 'MM/DD/YYYY';
